module.exports = __webpack_public_path__ + "static/media/login-bg.a621160c.png";